import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class PageTitleService {
  private _institution: string = "Scaffold";
  private _section: string = "";
  constructor(private titleService: Title) {}

  get institution() {
    return this._institution;
  }

  set institution(input) {
    this._institution = input;
    this.setTitle();
  }

  get section() {
    return this._section;
  }

  set section(input) {
    this._section = input;
    this.setTitle();
  }

  setTitle() {
    let title = "";
    if (this._institution) title = this._institution;
    if (this.section) title += title ? ` - ${this._section}` : this._section;
    if (!title) title = "Scaffold";

    this.titleService.setTitle(title);
  }
}
